import { BREAKPOINTS } from '@app/constants/breakpoints';
import { useIsScreenSize } from '@app/utils/hooks';
import React from 'react';

interface Context {
  isDesktop: boolean;
  isMobile: boolean;
  isTablet: boolean;
}

export const ProductDetailsLayoutContext = React.createContext<Nullable<Context>>(null);

export const useProductDetailsLayoutContext = () => {
  const context = React.useContext(ProductDetailsLayoutContext);

  if (!context) {
    throw new Error('useProductDetailsLayoutContext can not be used outside the scope of ProductDetailsLayoutContextProvider');
  }

  return context;
};

export const ProductDetailsLayoutContextProvider = ({ children }: React.PropsWithChildren) => {
  const isMobile = useIsScreenSize(BREAKPOINTS.SM);
  const isTablet = useIsScreenSize(BREAKPOINTS.LG) && !isMobile;
  const isDesktop = !isMobile && !isTablet;

  return <ProductDetailsLayoutContext.Provider value={{ isDesktop, isMobile, isTablet }}>{children}</ProductDetailsLayoutContext.Provider>;
};
